// extracted by mini-css-extract-plugin
export default {"loader":"loading_loader__vRpG7","l4":"loading_l4__wvIWz"};